import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Navbar from '../../commonComponents/Navbar';
import Footer from '../../commonComponents/Footer';
import WhyChooseCarRental from '../../Componentsss/CarRentalService/WhyChooseCarRental/WhyChooseCarRental';
import LocationCarRentalServe from '../../Componentsss/CarRentalService/LocationCarRentalServe/LocationCarRentalServe';
import BookYourRide from '../../Componentsss/CarRentalService/BookYouRide/BookYourRide';
import CarRentalServiceBanner from '../../Componentsss/CarRentalService/CarRentalServiceBanner/CarRentalServiceBanner';

const CarRentalService = () => {
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      {bannerLoaded && <Navbar />}
      <CarRentalServiceBanner onLoad={() => setBannerLoaded(true)} />
      {bannerLoaded && (
        <>
          <WhyChooseCarRental />
          <LocationCarRentalServe />
          <BookYourRide />
          <Footer />
        </>
      )}
    </>
  )
}

export default CarRentalService